<template>
  <div class="ResultsHeader" @click="broadcast('close-menus')">
    <div class="left">
      <h3>Results<span v-if="searchTerm != ''"> for &ldquo;{{ searchTerm }}&rdquo;</span>:</h3>

      <span v-if="resultsData.totalCount <= 100" class="count">Showing {{ resultsData.currentCount }} of {{ resultsData.totalCount }} results</span>
      <span v-if="resultsData.currentCount && (resultsData.totalCount > 100)" class="count">Page {{ currentPage }}: Showing results {{ ((this.currentPage - 1) * 100) + 1 }} to {{ resultsData.currentCount + (this.currentPage > 1 ? (this.currentPage - 1) * 100 : 0) }} of {{ resultsData.totalCount }}</span>

      <div class="filterTags">
        <FilterTag v-for="(filter, index) in activeFilters" :key="'ft-'+index" :filter="filter"></FilterTag>
        <FilterTag v-if="showDateRangeFilterTag && ((dateFilterFrom !== null && dateFilterFrom !== '') || (dateFilterTo !== null && dateFilterTo !== ''))" :filter="dateRangeFilter"></FilterTag>
        <span v-if="activeFilters.length > 0" @click="removeAllFilters()" class="remove">Remove all filters</span>
      </div>
    </div>
    <div class="right">
      <DisplayOptions :toggleDisplay="toggleDisplay"></DisplayOptions>
    </div>
  </div>
</template>

<script>
import FilterTag from '@/components/FilterTag'
import DisplayOptions from '@/components/DisplayOptions'
import { mapGetters } from 'vuex'

export default {
  name: 'ResultsHeader',
  components: {
    FilterTag,
    DisplayOptions
  },
  computed: {
    ...mapGetters({
      searchTerm: 'getSearchTerm',
      currentPage: 'getCurrentPage',
      resultsData: 'getResultsData',
      activeFilters: 'getActiveFilters',
      dateFilterFrom: 'getDateFilterFrom',
      dateFilterTo: 'getDateFilterTo',
    }),
  },
  props: {
    toggleDisplay: Function,
  },
  methods: {
    removeAllFilters: function () {
      this.$store.commit('updateCurrentPage', 1)
      this.$store.commit('updateActiveFilters', []) // needs to uncheck
      this.broadcast('uncheck-all-filters')
      this.broadcast('requery')
      this.broadcast('reset-date-values')
      this.broadcast('reset-state-value')
      this.broadcast('reset-person-value')

    }
  },
  mounted: function () {
    this.listenFor('requery', arg => {
      if (this.dateFilterFrom && this.dateFilterFrom !== '' && this.dateFilterFrom[0] !== '-') { // @TODO: fortify this check
        this.showDateRangeFilterTag = true
      } else {
        this.showDateRangeFilterTag = false
      }

      if (this.dateFilterTo && this.dateFilterTo !== '' && this.dateFilterTo[0] !== '-') { // @TODO: fortify this check
        this.showDateRangeFilterTag = true
      } else {
        this.showDateRangeFilterTag = false
      }
    })

    // @TODO: fix redundancy
    this.listenFor('initial', arg => {
      setTimeout(() => {
        if (this.dateFilterFrom && this.dateFilterFrom !== '' && this.dateFilterFrom[0] !== '-') { // @TODO: fortify this check
          this.showDateRangeFilterTag = true
        } else {
          this.showDateRangeFilterTag = false
        }

        if (this.dateFilterTo && this.dateFilterTo !== '' && this.dateFilterTo[0] !== '-') { // @TODO: fortify this check
          this.showDateRangeFilterTag = true
        } else {
          this.showDateRangeFilterTag = false
        }
      }, 2000) //@TODO: fix; brittle
    })
  },
  data() {
    return {
      showDateRangeFilterTag: false,
      dateRangeFilter: {
        shortname: 'dateRangeFilterTag',
        name: 'Date Range',
      }
    }
  },
};
</script>

<style scoped lang="scss">
  .ResultsHeader {
    padding-left: 30px;
    padding-bottom: 50px;
    @include cf;
    @include smx { padding-left: 15px; }

    h3 {
      font-size: 32px;
      font-weight: normal;
      padding-top: 48px;
    }

    .count {
      font-size: 18px;
      font-weight: normal;
      display: inline-block;
      padding-bottom: 24px;
    }
    .left {
      float: left;
      width: 70%;
      @include smx { width: 100%; float: none; }
    }

    .right {
      width: 30%;
      float: right;
      @include smx { width: 100%; float: none;}
    }

    .remove {
      display: inline-block;
      margin-left: 8px;
      color: $pink;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;

    }
  }
</style>
